export default __webpack_public_path__ + "static/media/studiopsv-logo.b497da01.svg";